const uploadedFile = {
  createUploadedFile: 'api/v2.5/uploaded_files',
}

export default uploadedFile
